<template>
	<AppDialog :dialogName="'InstallExtDialog'" @onCancel="dialogPromiseHandlers.reject()">
		<InstallPlyExtensionLoader class="dialog-content" @extension-installed="extensionInstalled" :minimalVersion="minimalVersion" />
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import InstallPlyExtensionLoader from '@/components/InstallPlyExtensionLoader.vue';
export default {
	name: 'InstallExtDialog',
	components: {
		InstallPlyExtensionLoader,
		AppDialog,
	},
	props: {
		dialogPromiseHandlers: { type: Object },
		minimalVersion: { type: String },
	},
	methods: {
		extensionInstalled() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
	},
};
</script>

<style scoped lang="scss">
.dialog-content {
	height: 380px;
	margin-top: 7px;
	margin-bottom: 20px;
	background: var(--white);
}
</style>
